import { render, staticRenderFns } from "./DropDownMenuServices.vue?vue&type=template&id=ba787bc6"
import script from "./DropDownMenuServices.vue?vue&type=script&lang=js"
export * from "./DropDownMenuServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports